<template>
    <div v-if="$store.state.isCheckFontSize" class="home__increase-font-size">
        <label class="home__increase-label">
            {{ getTranslatedText('size') }}
        </label>
        <div class="home__increase-radio">
            <RadioButton
                label="normal"
                :value="KEY_INFO.VALUE_NORMAL_INCREASE_FONTSIZE"
                :valueChecked="$store.state.increaseFontSize"
                @change:value="onChangeTypeBlock"
            />
            <RadioButton
                label="Large"
                :value="KEY_INFO.VALUE_LARGE_INCREASE_FONTSIZE"
                :valueChecked="$store.state.increaseFontSize"
                @change:value="onChangeTypeBlock"
            />
        </div>
    </div>
    <div class="home__footer">
        <ButtonCommon :isNoHover="true" icon="lock" value="CHANGE PIN" @on-click-button-common="onChangePin" />
        <ButtonCommon
            className="button-logout"
            :isNoHover="true"
            icon="sign-out"
            value="SIGN OUT"
            @on-click-button-common="onSignOut"
        />
    </div>
</template>
<script>
import ButtonCommon from '@/components/common/button/button.vue';
import RadioButton from '@/components/common/radio/radio.vue';
import languageMixins from '@/mixins/language-mixins';
import { KEY_INFO } from '@/constants/store';
import authService from '@/services/auth.service';

export default {
    mixins: [languageMixins],
    components: { ButtonCommon, RadioButton },
    data() {
        return {
            KEY_INFO,
        };
    },
    methods: {
        onSignOut() {
            this.$store.commit('SET_LOGOUT');
            this.$router.push({ name: 'Login', query: this.$route.query });
        },
        onChangePin() {
            this.$router.push({ name: 'ChangePinPage', query: this.$route.query });
        },
        async onChangeTypeBlock(value) {
            try {
                this.$store.commit('SET_INCREASE_FONTSIZE', value);
                await authService.changeTypeFontSize(value);
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
